export const SUGGESTIONS = [
  { name: 'Search Customers', icon: 'person', key: 'C', index: 'Customers' },
  { name: 'Search Orders', icon: 'cart', key: 'O', index: 'Orders' },
  { name: 'Search Products', icon: 'box', key: 'P', index: 'Products' },
];
